'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var nthBitHeader = require('@narvar/nth-bit-header');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Divider = require('@narvar/nth-bit-divider');
var Typography = require('../../../../../../common/components/Typography.js');
var nthBundleShippingActivity = require('@narvar/nth-bundle-shipping-activity');
var ClaimDetailsDescription = require('../../components/ClaimDetailsDescription.js');
var nthHookTheme = require('@narvar/nth-hook-theme');
var index = require('../../../../../../common/components/Icon/index.js');
var TextLink = require('@narvar/nth-bit-text-link');
var Box = require('../../../../../../common/components/layout/Box/Box.js');
var NarvarStatusChip = require('./NarvarStatusChip.js');
var ShippingActivityDisclosure = require('./ShippingActivityDisclosure.js');
var ItemsDisclosure = require('./ItemDisclosure/ItemsDisclosure.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

const Overview = _ref => {
  let {
    claim
  } = _ref;
  const {
    linksNoneDefault,
    linksNoneHover
  } = nthHookTheme.useTheme();
  const {
    claimsClaimDetailsShipmentsCarrierLink,
    claimsClaimDetailsShipmentsEddLabel,
    claimsClaimDetailsShipmentsCurrentStatusLabel,
    claimsClaimDetailsShipmentsTitle,
    claimsClaimDetailsShipmentsLabelPackage
  } = nthHookTranslations.useTranslations();
  const {
    shipments
  } = claim;
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 4
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    as: "h2"
  }, claimsClaimDetailsShipmentsTitle), shipments.map((shipment, i) => /*#__PURE__*/React__default["default"].createElement("div", {
    key: shipment.trackingNumber
  }, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 3
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    role: "heading",
    "aria-level": 3
  }, /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, mustache__default["default"].render(claimsClaimDetailsShipmentsLabelPackage ?? '', {
    index: i + 1,
    total: shipments.length
  })), /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    display: "flex",
    gap: 2,
    style: {
      fontSize: '1rem'
    }
  }, /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, {
    s: {
      fontSize: 'inherit'
    }
  }, shipment.trackingNumber), shipment.trackingUrl && /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    href: shipment.trackingUrl,
    linkStyle: {
      sDefault: {
        ...linksNoneDefault,
        fontSize: 'inherit'
      },
      sHover: {
        ...linksNoneHover,
        fontSize: 'inherit'
      }
    }
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    icon: "OpenInNew",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React__default["default"].createElement("title", null, claimsClaimDetailsShipmentsCarrierLink)))), /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, shipment.serviceDescription)), shipment.status && /*#__PURE__*/React__default["default"].createElement(NarvarStatusChip["default"], {
    status: shipment.status,
    statusCode: shipment.statusCode
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      width: '100%',
      margin: '0.75rem 0 0.5rem 0'
    }
  }, /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null)), /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 3
  }, /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionList, null, /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionRow, null, shipment.eddFormatted && /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescription, {
    label: claimsClaimDetailsShipmentsEddLabel,
    value: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", null, shipment === null || shipment === void 0 ? void 0 : shipment.eddFormatted[0]), /*#__PURE__*/React__default["default"].createElement("div", null, shipment === null || shipment === void 0 ? void 0 : shipment.eddFormatted[1]))
  }), /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescription, {
    label: claimsClaimDetailsShipmentsCurrentStatusLabel,
    value: /*#__PURE__*/React__default["default"].createElement(nthBundleShippingActivity.TrackingEventDescription, {
      formattedDescription: shipment.history[0].formattedDescription,
      description: shipment.history[0].description,
      linkDefault: linksNoneDefault,
      linkHover: linksNoneHover
    })
  }))), /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 2
  }, /*#__PURE__*/React__default["default"].createElement(ShippingActivityDisclosure["default"], {
    shipment: shipment
  }), /*#__PURE__*/React__default["default"].createElement(ItemsDisclosure["default"], {
    shipment: shipment
  }))))));
};
var Shipments = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(Overview, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover']
}), {
  translationKeys: ['claimsClaimDetailsShipmentsCarrierLink', 'claimsClaimDetailsShipmentsTitle', 'claimsClaimDetailsShipmentsCurrentStatusLabel', 'claimsClaimDetailsShipmentsEddLabel', 'claimsClaimDetailsShipmentsLabelPackage']
});

exports["default"] = Shipments;
